"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MomentFilters = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../../index");

var _filters = require("./filters");

require("./MomentFilters.css");

var _excluded = ["onChange", "className", "style"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Moment Filters Modal
var MomentFiltersModal = function MomentFiltersModal(_ref) {
  var open = _ref.open,
      selectedFilters = _ref.selectedFilters,
      filters = _ref.filters,
      onClose = _ref.onClose,
      onSelection = _ref.onSelection;
  var soccerFilters = filters.filter(function (f) {
    return f.sport_type === 'soccer';
  });
  var baseballFilters = filters.filter(function (f) {
    return f.sport_type === 'baseball';
  });

  var renderTag = function renderTag(filters) {
    return filters.map(function (filter) {
      var name = filter.name;
      var isSelected = selectedFilters.has(name);
      var textColor = isSelected ? _index.Color.White2 : _index.Color.Black;
      var backgroundColor = isSelected ? _index.Color.Black : _index.Color.Grey4;
      return /*#__PURE__*/_react.default.createElement(_index.Chip, {
        fat: true,
        touchable: true,
        key: "moment-filter-chip-".concat(filter.name),
        className: "moment-filter",
        borderRadius: "var(--spacing-12x)",
        marginRight: 2,
        color: textColor,
        background: backgroundColor,
        onClick: function onClick(e) {
          return onSelection(name, isSelected);
        },
        content: /*#__PURE__*/_react.default.createElement(_index.Label, null, name.toLowerCase())
      });
    });
  };

  return /*#__PURE__*/_react.default.createElement(_index.Modal, {
    open: open,
    className: "MomentFiltersModal",
    onShadeClick: function onShadeClick() {
      onClose();
    }
  }, /*#__PURE__*/_react.default.createElement(_index.TitleSection, {
    onCloseClick: function onCloseClick() {
      onClose();
    }
  }, /*#__PURE__*/_react.default.createElement(_index.ModalTitle, {
    content: "More tags"
  })), /*#__PURE__*/_react.default.createElement(_index.ContentSection, null, /*#__PURE__*/_react.default.createElement(_index.Column, {
    marginBottom: "4"
  }, /*#__PURE__*/_react.default.createElement(_index.Label, {
    type: _index.Label.Type.Heading5,
    color: _index.Color.Grey2,
    content: "Soccer",
    center: true,
    marginBottom: "4"
  }), /*#__PURE__*/_react.default.createElement(_index.Row, {
    justifyContent: "center"
  }, renderTag(soccerFilters)), /*#__PURE__*/_react.default.createElement(_index.Label, {
    type: _index.Label.Type.Heading5,
    color: _index.Color.Grey2,
    content: "Baseball/Softball",
    center: true,
    marginTop: "4",
    marginBottom: "4"
  }), /*#__PURE__*/_react.default.createElement(_index.Row, {
    justifyContent: "center"
  }, renderTag(baseballFilters)))));
}; // Moment Filters


var MomentFilters = function MomentFilters(_ref2) {
  var onChange = _ref2.onChange,
      className = _ref2.className,
      style = _ref2.style,
      props = _objectWithoutProperties(_ref2, _excluded);

  var cn = className ? "MomentFilters ".concat(className) : "MomentFilters";

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      openModal = _useState2[0],
      setOpenModal = _useState2[1]; // Selected filters


  var defaultSelectedFilters = new Set(["All"]);

  var _useState3 = (0, _react.useState)(defaultSelectedFilters),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedFilters = _useState4[0],
      setSelectedFilters = _useState4[1]; // Call onChange


  (0, _react.useEffect)(function () {
    if (typeof onChange === "function") {
      onChange(selectedFilters);
    }
  }, [selectedFilters]);

  var handleFilterOnClick = function handleFilterOnClick(name, isAlreadySelected) {
    var filtersToUpdate;

    if (name === "All" && !isAlreadySelected) {
      // If we're selecting All when other filters are already selected
      filtersToUpdate = new Set(["All"]);
    } else if (name !== "All") {
      // If we're selecting other filters when all is not selected
      filtersToUpdate = new Set(selectedFilters);
      filtersToUpdate.delete("All");
      isAlreadySelected ? filtersToUpdate.delete(name) : filtersToUpdate.add(name);
    }

    if (filtersToUpdate.size === 0) filtersToUpdate.add("All");
    setSelectedFilters(filtersToUpdate);
  };

  var setArrayIntersectionCount = function setArrayIntersectionCount(aSet, anArray) {
    var count = 0;
    anArray.forEach(function (value) {
      count += aSet.has(value.name) ? 1 : 0;
    });
    return count;
  }; // More tags styling


  var moreTagsFilters = _filters.FILTERS.slice(4);

  var intersectionCount = setArrayIntersectionCount(selectedFilters, moreTagsFilters);
  var moreTagsColor = intersectionCount > 0 ? _index.Color.White2 : _index.Color.Black;
  var moreTagsTitle = intersectionCount > 0 ? "+".concat(intersectionCount, " more") : "More tags";
  var moreTagsBackgroundColor = intersectionCount > 0 ? _index.Color.Black : _index.Color.Grey4;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_index.Row, _extends({
    alignItems: "center",
    trkContext: "Moment Filters",
    className: cn,
    padding: "4 2",
    width: "100%",
    style: style
  }, props), _filters.FILTERS.slice(0, 4).map(function (filter) {
    var name = filter.name;
    var isSelected = selectedFilters.has(name);
    var textColor = isSelected ? _index.Color.White2 : _index.Color.Black;
    var backgroundColor = isSelected ? _index.Color.Black : _index.Color.Grey4;
    return /*#__PURE__*/_react.default.createElement(_index.Chip, {
      fat: true,
      touchable: true,
      trkAction: "".concat(filter.name, " Filter ").concat(isSelected ? "Unselected" : "Selected"),
      key: "moment-filter-chip-".concat(filter.name),
      className: "moment-filter",
      borderRadius: "var(--spacing-12x)",
      marginRight: 2,
      color: textColor,
      background: backgroundColor,
      onClick: function onClick(e) {
        return handleFilterOnClick(name, isSelected);
      },
      content: /*#__PURE__*/_react.default.createElement(_index.Label, null, name)
    });
  }), /*#__PURE__*/_react.default.createElement(_index.Chip, {
    fat: true,
    touchable: true,
    className: "moment-filter",
    marginRight: 2,
    color: moreTagsColor,
    background: moreTagsBackgroundColor,
    borderRadius: "var(--spacing-12x)",
    onClick: function onClick(e) {
      return setOpenModal(true);
    },
    content: /*#__PURE__*/_react.default.createElement(_index.Label, null, moreTagsTitle),
    icon: _index.Icon.Type.CheveronDown,
    icon_on_right: true
  })), /*#__PURE__*/_react.default.createElement(MomentFiltersModal, {
    open: openModal,
    filters: moreTagsFilters,
    onSelection: function onSelection(filterName, isFilterSelected) {
      return handleFilterOnClick(filterName, isFilterSelected);
    },
    selectedFilters: selectedFilters,
    onClose: function onClose() {
      return setOpenModal(false);
    }
  }));
};

exports.MomentFilters = MomentFilters;